/* unplugin-vue-components disabled */import { render } from "./logisticsAdd.vue?vue&type=template&id=c210dc4c&scoped=true"
import script from "./logisticsAdd.vue?vue&type=script&lang=js"
export * from "./logisticsAdd.vue?vue&type=script&lang=js"

import "./logisticsAdd.vue?vue&type=style&index=0&id=c210dc4c&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c210dc4c"]])

export default __exports__